import React from 'react';
import { Box } from '@mui/material';
import { ICONS, IconName } from '../../constants/icons';
import CommonDetailsContext from '../../context/Common/common';
import { tokens } from '../../theme/tokens';

interface GoogleMaterialIconProps {
  name: IconName;
  size?: number;
  color?: string;
  fill?: 0 | 1;
  weight?: 100 | 200 | 300 | 400 | 500 | 600 | 700;
  grade?: number;
  sx?: any;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const GoogleMaterialIcon: React.FC<GoogleMaterialIconProps> = ({
  name,
  size = 24,
  color = 'primary',
  fill = 0,
  weight = 400,
  grade = 0,
  sx,
  onClick,
  className,
  style,
}) => {
  const commonDetailsContext = React.useContext(CommonDetailsContext);
  const activeBranding = commonDetailsContext?.validateParentData?.isSingleParent
    ? commonDetailsContext?.publishedBranding
    : (commonDetailsContext?.clientScopedBranding || commonDetailsContext?.publishedBranding);
  const brandedPrimaryColor =
    activeBranding?.primaryColor || tokens.colors.connectedPurple;
  const resolvedColor =
    color === 'primary' || color === tokens.colors.connectedPurple
      ? brandedPrimaryColor
      : color;

  return (
    <Box
      component="span"
      onClick={onClick}
      className={className ? `material-symbols-outlined ${className}` : "material-symbols-outlined"}
      style={{
        fontFamily: 'Material Symbols Outlined',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontSize: `${size}px`,
        lineHeight: 1,
        letterSpacing: 'normal',
        textTransform: 'none',
        display: 'inline-block',
        whiteSpace: 'nowrap',
        wordWrap: 'normal',
        direction: 'ltr',
        color: resolvedColor,
        fontVariationSettings: `'FILL' ${fill}, 'wght' ${weight}, 'GRAD' ${grade}, 'opsz' ${size}`,
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
      sx={{
        ...sx,
      }}
    >
      {ICONS[name]}
    </Box>
  );
};
